// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2lLgU","label":"Completed_label__2ZYJS"};